// Multi-select language tab filter for Home page rails
const LANGUAGES = [
  { code: "hi", label: "Hindi" },
  { code: "en", label: "English" },
  { code: "ta", label: "Tamil" },
  { code: "te", label: "Telugu" },
  { code: "ml", label: "Malayalam" },
  { code: "kn", label: "Kannada" },
  { code: "ko", label: "Korean" },
  { code: "ja", label: "Japanese" },
  { code: "es", label: "Spanish" },
];

export default function LanguageFilter({ values = [], onChange }) {
  const toggle = (code) => {
    const next = values.includes(code) ? values.filter(v => v !== code) : [...values, code];
    onChange(next);
  };
  const clear = () => onChange([]);

  return (
    <div className="px-6 lg:px-10 mt-2" data-testid="language-filter">
      <div className="max-w-[1440px] mx-auto flex items-center gap-2 overflow-x-auto scrollbar-hide pb-2">
        <span className="text-xs uppercase tracking-[0.2em] text-neutral-500 font-semibold mr-2 whitespace-nowrap">
          Language
        </span>
        <button
          onClick={clear}
          data-testid="lang-btn-all"
          className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors border ${
            values.length === 0
              ? "bg-[#E50914] text-white border-[#E50914]"
              : "bg-white/[0.03] text-neutral-300 border-white/10 hover:border-white/30 hover:text-white"
          }`}
        >
          All
        </button>
        {LANGUAGES.map((l) => {
          const active = values.includes(l.code);
          return (
            <button
              key={l.code}
              onClick={() => toggle(l.code)}
              data-testid={`lang-btn-${l.code}`}
              className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors border ${
                active
                  ? "bg-[#E50914] text-white border-[#E50914]"
                  : "bg-white/[0.03] text-neutral-300 border-white/10 hover:border-white/30 hover:text-white"
              }`}
            >
              {l.label}
            </button>
          );
        })}
        {values.length > 0 && (
          <span className="ml-2 text-[10px] text-neutral-500 font-mono-fm whitespace-nowrap">
            {values.length} selected
          </span>
        )}
      </div>
    </div>
  );
}
